import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import { fullNameSchema } from '../../../definitions/sharedSchema';
import {
  dobUI,
  fullNameUI,
  genderUI,
  vetRelationshipUI,
} from '../../../definitions/sharedUI';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['secondary-one-info-title--personal'];
const INPUT_LABEL = content['secondary-one-input-label'];
const HINT_TEXT = content['secondary-hint-label'];

const { fullName, date, gender, vetRelationship } = FULL_SCHEMA.definitions;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    secondaryOneFullName: fullNameUI({
      label: INPUT_LABEL,
      labelAlt: HINT_TEXT,
    }),
    secondaryOneDateOfBirth: dobUI(INPUT_LABEL),
    secondaryOneGender: genderUI(INPUT_LABEL),
    secondaryOneVetRelationship: vetRelationshipUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    required: [
      'secondaryOneFullName',
      'secondaryOneDateOfBirth',
      'secondaryOneVetRelationship',
    ],
    properties: {
      secondaryOneFullName: fullNameSchema(fullName),
      secondaryOneDateOfBirth: date,
      secondaryOneGender: gender,
      secondaryOneVetRelationship: vetRelationship,
    },
  },
};
